// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2021-09-17 14:53:21 +0200 (Fri, 17 Sep 2021) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 121700 $
// Purpose     : config dashboard panels
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {isString} from 'ldash'
import log from 'uix/logging'
import {DashSegment} from 'uix/components/grid'

// ---Local imports
import {DomainConfigTable, ConfigMenu} from './components'

// ---Exports

const DomainConfigPanel = ({section, header = 'Konfiguration', i18n}) => {
  if (isString(section)) {
    section = [section]
  }
  return (
    <DashSegment header={header} menu={<ConfigMenu basic />}>
      {section.map((sec, i) => (
        <DomainConfigTable key={sec} basic section={sec} />
      ))}
    </DashSegment>
  )
}

export const DashDomainConfig = {
  Comp: DomainConfigPanel,
  datatypes: ['domain'],
}
